import UserSession from '../utils/class/UserSession'
import { axiosInstance } from './../../shared/services/axios-instance'
import * as endpoints from './../constants/api-constants'

class CompetitionService {
  static getIdToken() {
    return {
      headers: {
        Authorization: UserSession.getTokenStorage()?.idToken || '',
      },
    }
  }

  static async getAccumulationsTotal(payload) {
    return axiosInstance
      .get(endpoints.getAccumulationsTotal + payload)
      .then(resp => resp.data)
  }

  static async getIsWinner(concourseId) {
    const config = this.getIdToken()
    return axiosInstance
      .get(endpoints.getIsWinner + '?concourseId=' + concourseId, config)
      .then(resp => resp.data)
  }

  static async getTickets(concourseId) {
    const config = this.getIdToken()
    return axiosInstance
      .get(endpoints.getTickets + '?concourseId=' + concourseId, config)
      .then(resp => resp.data)
  }

  static async getProductKey(key) {
    return axiosInstance
      .get(endpoints.getProductKey + '?key=' + key)
      .then(resp => resp.data)
  }

  static async postRedeemKeyWithoutPoints(concourseId, payload) {
    const config = this.getIdToken()
    return axiosInstance
      .post(
        endpoints.postRedeemKeyWithoutPoints + '?concourseId=' + concourseId,
        payload,
        config
      )
      .then(resp => resp.data)
  }

  static async postRedeemParticipationGoal(concourseId) {
    const config = this.getIdToken()
    return axiosInstance
      .post(
        endpoints.postRedeemParticipationGoal + '?concourseId=' + concourseId,
        {},
        config
      )
      .then(resp => resp.data)
  }
}

export default CompetitionService
